import { gql } from '@apollo/client';

export const SHARE_CONTENT = gql`
  mutation shareContent($input: CreateContentShareInput!) {
    shareContent(input: $input) {
      result {
        id
      }
    }
  }
`;

export const UPDATE_SHARE_PERMISSION = gql`
  mutation updateSharePermission($input: UpdatePermissionInput!) {
    updateSharePermission(input: $input) {
      result {
        id
      }
    }
  }
`;

export const REVOKE_CONTENT_SHARE = gql`
  mutation revokeShare($shareId: String!) {
    revokeShare(shareId: $shareId) {
      result {
        id
      }
    }
  }
`;

export const UPDATE_SHARE_STATUS = gql`
  mutation updateShareStatus($shareId: String!, $input: UpdateContentShareInput!) {
    updateShareStatus(shareId: $shareId, input: $input) {
      result {
        id
      }
    }
  }
`;
